module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider"
  }, [(_vm.list.length > _vm.limit) ? _c('i', {
    staticClass: "el-icon-arrow-left",
    on: {
      "click": function($event) {
        _vm.moveLeft()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > _vm.limit) ? _c('i', {
    staticClass: "el-icon-arrow-right",
    on: {
      "click": function($event) {
        _vm.moveRight()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "slider-view",
    style: ({
      width: _vm.calc_width + 'px'
    })
  }, [_c('div', {
    ref: "wrap",
    staticClass: "slider-wrap"
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "slider-item",
      style: ({
        'border-color': _vm.color
      })
    }, [_c('div', {
      staticClass: "head overhide",
      style: ({
        'background': _vm.color
      }),
      attrs: {
        "title": item.currency_name
      }
    }, [_vm._v(_vm._s(item.currency_name))]), _vm._v(" "), _c('div', {
      staticClass: "main",
      style: ({
        'color': _vm.color
      })
    }, [_vm._v(_vm._s(_vm.text) + "："), _c('span', [_vm._v(_vm._s(item[_vm.valueKey] || 0))]), _vm._v("币")])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-40d0d9a3!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/asset-slider.vue
// module id = 732
// module chunks = 1